module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.emitSubmit($event)
      }
    }
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.submitting
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.text),
      expression: "text"
    }],
    ref: "textarea",
    staticClass: "form-control",
    attrs: {
      "cols": "30",
      "rows": "2",
      "required": "",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.text)
    },
    on: {
      "focus": function($event) {
        _vm.$emit('focus')
      },
      "blur": function($event) {
        _vm.$emit('blur')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.text = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(!!_vm.text.length) ? _c('button', {
    class: {
      'form-button': true, 'disabled': this.submitting
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.submitText) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.cancelable) ? _c('button', {
    class: {
      'clear-button': true, 'disabled': this.submitting
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.emitCancel
    }
  }, [_vm._v("\n                Cancel\n            ")]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d0d1aeca!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/GalleryCommentForm.vue
// module id = 2104
// module chunks = 2